import Footer from "@/components/navigation/Footer";
import NavBar from "@/components/navigation/NavBar";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import FeatureSection from "@/components/design/FeaturesSection";
import GoogleTestimonials from "@/components/Landingpage/GoogleRating";
import { CalendarDateRangeIcon } from "@heroicons/react/24/outline";
import { IconHomeCheck } from "@tabler/icons-react";
import VerticalTabs from "@/components/design/VerticalTabs";
import { StepsTracing } from "@/components/design/StepsTracing";
import CtaLogoCloud from "@/components/calltoaction/CtaLogoCloud";
import Reveal from "@/components/Motion/Reveal";
import VorteileSectionVerkaufen from "@/components/design/VorteileSectionVerkaufen";
import Proof from "@/components/proofs/Proof";
import ButtonPrime from "@/components/navigation/ButtonPrime";
import ButtonStroke from "@/components/navigation/ButtonStroke";
import ContactOptionsTabs from "@/components/calltoaction/CtaContact";
import BeratungsterminModal from "@/components/form/BeratungsterminModal";
import FaqSection from "@/components/navigation/faq";

export default function VerkaufenLandingpage() {

  // const formTitles = {
  //   immobilie: "Immobilienverkauf",
  //   haus: "Hausverkauf",
  //   wohnung: "Wohnungsverkauf",
  //   mehrfamilienhaus: "Mehrfamilienhausverkauf",
  // };

  // const formTitle = formTitles[type] || "Immobilienverkauf";
  return (
    <div className=" bg-white">
      <NavBar className="bg-opacity-100  border-none shadow-none" />

      <div className="pt-[3rem] px-2 mx-auto">
        <div className=" mx-auto px-4 sm:px-6 lg:px-8">
          <div className="md:grid  flex flex-col-reverse max-w-[95rem] mx-auto md:grid-cols-2 reverse py-10 gap-4 md:gap-8 xl:gap-20 md:items-center">
            <div className="md:pt-20  pt-10">
              <h1 className="block text-3xl font-serif font-bold text-dark-100 sm:text-3xl lg:text-5xl lg:leading-tight">
                Der erste Schritt zum Immobilienverkauf
              </h1>
              <p className="mt-3 text-lg text-gray-600">
                Lassen Sie sich persönlich beraten oder starten Sie mit einer
                kostenlosen Bewertung – damit Sie mit gutem Gefühl entscheiden
                können.
              </p>

              <div className="space-y-5 md:w-[25rem]">
                <BeratungsterminModal
                 onClick={() =>
                  umami.track(
                    `verkaufengpage_hero_beratungstermin`,
                    "click"
                  )
                }
                  trigger={
                    <ButtonPrime
                     
                      className="w-full mt-10"
                      icon={
                        <CalendarDateRangeIcon className=" stroke-gray-100 size-7" />
                      }
                      text="Beratungstermin vereinbaren"
                    />
                  }
                />
                <div
                  onClick={() =>
                    umami.track(`verkaufengpage_hero_online-bewertung`, "click")
                  }
                >
                  <ButtonStroke
                    className="w-full relative"
                    url="/bewerten/formular/online-bewertung"
                    icon={
                      <IconHomeCheck className=" stroke-prime-600 size-7" />
                    }
                    text="Immobilienwert erfahren"
                  />
                </div>
              </div>

              <div className="pt-5 md:pt-10 md:w-[33rem]">
                <Proof />
              </div>
              <div className="mt-6 lg:mt-10 grid grid-cols-2 gap-x-5"></div>
            </div>
            <div className="relative  h-full  md:ms-4">
              <img
                className="w-full h-full object-cover rounded-md"
                src="/Fotos/verkaufen-hero-jakobs.jpg"
                alt="Leon Jakobs und Helga Jakobs am Büro auf der Uferstraße 40"
              />
            </div>
          </div>
        </div>
        <div>
          <VorteileSectionVerkaufen />
        </div>
        <div className=" pt-8 md:py-20 pb-10 max-w-[85rem]  sm:px-6 lg:px-8 mx-auto">
          <hr className="py-5" />
          <h2 className="text-2xl md:text-3xl px-3 text-dark-200 font-serif font-bold pb-16">
            So funktioniert der Verkauf mit uns
          </h2>
          <VerticalTabs />
          <hr className="mt-10 md:hidden" />
        </div>

        <div className=" pb-20">
          <StepsTracing />
        </div>
        <div className="bg-gray-50">
          <CtaLogoCloud />
        </div>
        <Reveal>
          <FeatureSection />
        </Reveal>

        <div className=" rounded-md py-10 md:px-5">
          <GoogleTestimonials />
        </div>
        <div></div>
      </div>
      <div className="pt-10">
        <ContactOptionsTabs />
      </div>
      <div>
        <FaqSection faqArt="verkaufen"/>
      </div>

      <Footer />
    </div>
  );
}
